import api from ".";
import { ISuggestion } from "src/screens/tripSmartRoute/type";

export interface ISmartRoutePreferenceRequest {
  origin: string;
  destination: string;
  roads: string[];
  fuelPrice: number;
  fuel_rate: number;
  operationalCost: number;
  mileage: number;
  timeWeight: number;
  strategies: string[];
  engine_speed: number;
  avoidToll: boolean;
  avoidAreas: string;
  vehicle: {
    grossWeight: number;
    height: number;
    width: number;
    length: number;
    shippedHazardousGoods: string;
    numberOfAxles: number;
    trailerAxles: number;
  };
  transport: {
    mode: string;
  };
  departureTime: string;
  original_route: {
    distance: number;
    duration: number;
    total_cost: number;
  };
}

export interface ISmartRoutePreferenceResponse {
  suggestions: ISuggestion[];
  success: boolean;
  message?: string;
}

export const fetchSmartRoutePreferences = async (body: ISmartRoutePreferenceRequest): Promise<ISuggestion[]> => {
  try {
    const response = await api.post("v1/orchestrator/routes/predict", body);
    return response.data;
  } catch (error: any) {
    console.error("Erro ao buscar preferências de rota inteligente:", error);
    throw new Error(error?.response?.data?.message || "Erro ao buscar preferências de rota inteligente");
  }
};
export interface ISendSmartRouteRequest {
  routeName: string;
  originRoute: {
    address: {
      label: string;
    };
    addressStop: {
      label: string;
    };
    lat: number;
    lng: number;
  };
  destinyRoute: {
    address: {
      label: string;
    };
    addressStop: {
      label: string;
    };
    lat: number;
    lng: number;
  };
  rangeToleranceLimit: number;
  stops: any[];
  roadParameters: {
    trafficConditions: string;
    avoidToll: boolean;
    avoidRoad: boolean;
    ignoreTrafficRestrictions: boolean;
  };
  vehicleVocationalInfo: {
    height: number;
    width: number;
    comTotal: number;
    grossWeight: number;
    maxAxleLoad: number;
    numberOfAxles: number;
    trailerAxles: number;
    type: string;
    shippedHazardousGoods: string;
  };
  costs: {
    tollValue: string;
    operativeCosts: string;
    fuelAverageCosts: string;
    averageConsume: string;
    totalCosts: string;
  };
  responsibleId: string;
  status: boolean;
  linkedVehicles: any[];
  responseHere: {
    routes: any[];
  };
  duration: string;
}

export const sendSmartRoutePreferences = async (routeData: ISendSmartRouteRequest): Promise<any> => {
  try {
    const response = await api.post("/v2/routes/rio/send", routeData);
    return response.data;
  } catch (error: any) {
    console.error("Erro ao enviar rota inteligente:", error);
    throw new Error(error?.response?.data?.message || "Erro ao enviar rota inteligente");
  }
};

